import React from "react";
import { Link } from "react-router-dom";
import logoImg from "images/logo/logo.png";
import logoLightImg from "images/logo/logo-light.png";

export interface LogoProps {
  img?: string;
  imgLight?: string;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({
  img = logoImg,
  imgLight = logoLightImg,
  className = "flex-shrink-0",
}) => {
  return (
    <Link
      to="/"
      className={`ttnc-logo inline-block text-slate-600 ${className}`}
    >
      {/* THIS USE FOR MY CLIENT */}
      {/* PLEASE UN COMMENT BELLOW CODE AND USE IT */}
      {/* <div className="anim-logo-bx bg-[white] dark:bg-[#111827]">
        <div className="icon-r-ani">
            <div className="icons-f"></div>
            <div className="icons-b"></div>
        </div>
      </div> */}
      {img ? (
        <img
          className={`block max-h-8 sm:max-h-10 ${imgLight ? "" : ""
            }`}
          src={"/logo192.png"}
          alt="Logo"
          style={{
            width: "20px !important",
          }}
        />
      ) : (
        "Logo Here"
      )}
      {imgLight && (
        <img
          className="hidden max-h-8 sm:max-h-10"
          src={imgLight}
          alt="Logo-Light"
        />
      )}
    </Link>
  );
};

export default Logo;
